import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqs = [
  {
    q: 'What is a Basetao spreadsheet?',
    a: 'It is a simple table used to organize the products you find — including names, categories, prices, sellers, links and status — so you can compare and track everything in one place.',
  },
  {
    q: 'Is this website affiliated with Basetao?',
    a: 'No. Basetao Sheet Guide is an independent informational resource and is not affiliated with or endorsed by Basetao.',
  },
  {
    q: 'How do I use the category links?',
    a: 'Choose a category from the dropdown or the grid below, and you will be taken to the matching product list on the main website in a new tab.',
  },
  {
    q: 'How do I track prices in a spreadsheet?',
    a: 'Add a price column for each product and update it whenever you check a listing. This makes it easy to spot price changes and compare sellers over time.',
  },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/60">
      <div className="mx-auto max-w-content px-4 md:px-6 py-12 md:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t('faq.title')}
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('faq.subtitle')}</p>
        </div>

        <div className="mx-auto mt-8 max-w-3xl space-y-3">
          {faqs.map((faq, i) => {
            const open = openIndex === i;
            return (
              <div
                key={faq.q}
                className="rounded-lg border border-background-200/70 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-900 md:text-base">
                    {faq.q}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'} text-base`} />
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}